import { render } from "./JumpLinkPlus.vue?vue&type=template&id=6b2fc8e4&scoped=true"
import script from "./JumpLinkPlus.vue?vue&type=script&lang=js"
export * from "./JumpLinkPlus.vue?vue&type=script&lang=js"

import "./JumpLinkPlus.vue?vue&type=style&index=0&id=6b2fc8e4&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b2fc8e4"]])

export default __exports__